import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { href: String }

  open() {
    window.location=this.hrefValue
  }
}
